export abstract class AbstractIdbaModel {
  rowid: string;
  id: number | null = null;
  displayWith: string;

  constructor(object?) {
    var self = this;
    if (object) {
      Object.keys(object).forEach(function (k) {
        self[k] = object[k];
      });
    }
  }

  public abstract display(self: any): string;
  public abstract displayCodigo(self: any): string;
  public abstract displayNome(self: any): string;
  public abstract convertToModel(data: any): AbstractIdbaModel;

  public abstract filter(value: string, objectList: any[]): any[];

}
